module.exports = __webpack_public_path__ + "img/logo-argusblack.ec70cd7b.png";